import { __rest } from "tslib";
import * as React from 'react';
export const SelectColumn = (_a) => {
    var { children = null, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    className, onSelect = null } = _a, props = __rest(_a, ["children", "className", "onSelect"]);
    return (React.createElement(React.Fragment, null,
        React.createElement("input", Object.assign({}, props, { type: "checkbox", onChange: onSelect })),
        children));
};
SelectColumn.displayName = 'SelectColumn';
//# sourceMappingURL=SelectColumn.js.map